import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cropWithDotsCenter',
  standalone: true,
})
export class CropWithDotsCenterPipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    start = 10,
    end = 10
  ): string | null | undefined {
    if (!value) {
      return value;
    }
    if (value.length < start + end) {
      return value;
    }
    return `${value.slice(0, start)}...${value.slice(value.length - end)}`;
  }
}
